import React from 'react';

import { Tag, TagProps } from './tag';
const getTaskTypeColor = (value: string): TagProps['color'] => {
  if (value === 'Financial Statements') {
    return 'pink-light';
  }

  if (value === 'Tax Return') {
    return 'blue-light';
  }

  return 'teal-light';
};

// Note that `variant` is no-longer a valid prop because we're using `taskType` to control the appearance
// and we're also using it for the label
type Props = { type: string; testId?: string } & Omit<
  TagProps,
  'variant' | 'label'
>;
export const TaskTypeTag = ({
  testId = `task-type-tag`,
  type,
  ...props
}: Props) => {
  return (
    <Tag
      color={getTaskTypeColor(type)}
      label={type}
      {...props}
      data={{ testid: testId }}
    />
  );
};
